module.exports = __webpack_public_path__ + "static/Road-b46ba2049310a323905e0cd749e54745.mp4";